import { render, staticRenderFns } from "./JpHeader.vue?vue&type=template&id=27b0af7c&scoped=true"
import script from "./JpHeader.vue?vue&type=script&lang=js"
export * from "./JpHeader.vue?vue&type=script&lang=js"
import style0 from "./JpHeader.vue?vue&type=style&index=0&id=27b0af7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b0af7c",
  null
  
)

export default component.exports